import { Injectable } from '@angular/core';
import { HttpRequestService } from 'src/app/shared/services/http-request.service';
import { Globals } from 'src/app/shared/services/globals';
import { TranslateService } from '@ngx-translate/core';
import { Question } from 'src/app/shared/models/VM/Question';
import { Exam } from 'src/app/shared/models/VM/Exam';

@Injectable({
  providedIn: 'root'
})
export class ExamService {
  getQtype(v: any) {

   return this.translate.get('v').toPromise();
  }

  constructor(private httpRes: HttpRequestService,
              private globals: Globals,
              private translate: TranslateService) { }

   addExam(exam: Exam)
  {
   return this.httpRes.postRequest('Exams', exam).toPromise();
  }

  get(code, courseCode, page, pageSize)
  {
    return this.httpRes.GetRequest('Exams/Exams/' + code + '/' + courseCode + '/' + page + '/' + pageSize).toPromise();
  }
  addQuestions(question , Id)
  {
    return this.httpRes.postRequest('Exams/Questions', {examId: Id, questions: question}).toPromise();
  }
  addStudents(student , Id)
  {
    return this.httpRes.postRequest('Exams/Students', {examId: Id, students: student}).toPromise();
  }

  addEvaluator(evals , Id)
  {
    return this.httpRes.postRequest('Exams/Evaluators', {examId: Id, Evaluators: evals}).toPromise();
  }

   geExams(courseCode, bankID, qType, tags, createdBy)
   {
  return  this.httpRes.GetRequest('questions/' + courseCode + '/' + bankID + '/' + qType + '/' + tags + '/' + createdBy + '/').toPromise();

   }

   getExam(id)
   {
    return this.httpRes.GetRequest('exams/' + id).toPromise();

   }
   deleteExam(id)
   {
     return this.httpRes.postRequest('exams/delete', id).toPromise();
   }

}
